import type { PaymentRequestStatus } from "../types/directDebit.types";

export const CENTS_PER_EURO = 100;

export const DEV_MOCK_AMOUNT_CENTS = 424_242;

// Past this, the CRM is considered unreachable: the user is told instead of staring at a spinner.
export const CRM_ANSWER_WAIT_MAX_MS = 30_000;

// Past this, Stripe.js is considered blocked (proxy, filtering): the card field says so instead of showing a skeleton forever.
export const STRIPE_LOAD_TIMEOUT_MS = 15_000;

export const PAYMENT_NOT_STARTED_MESSAGE = "Le paiement n'a pas pu démarrer. Réessayez dans quelques minutes ou contactez le support.";

export const PAYMENT_NOT_COMPLETED_MESSAGE = "Le paiement n'a pas abouti.";

// Stripe.js threw without a message of its own (lost connection, broken intent): tell what to do next.
export const CARD_CONFIRMATION_FAILED_MESSAGE = "Le paiement n'a pas pu être confirmé. Vérifiez votre connexion puis réessayez, ou contactez le support.";

export const CARD_UNAVAILABLE_MESSAGE = "Le paiement par carte est momentanément indisponible.";

export const CARD_DECLINED_MESSAGE = "Le paiement a été refusé.";

// The CRM will not carry these out: the rejections are free again, and a new request may be asked.
export const DEAD_REQUEST_STATUSES: PaymentRequestStatus[] = ["refused", "failed", "expired"];

// Aligned with the expiry of a card request in the CRM: until then the request locks the rejections,
// so no other payment method can be asked for.
export const CARD_REQUEST_EXPIRY_HOURS = 24;

// The webhook that lifts the block lands seconds after Stripe confirms: poll until it does.
export const UNPAID_ORG_POLL_MS = 5_000;

// Past this the webhook is late, not slow: stop polling and tell the user their payment is safe.
export const UNPAID_ORG_POLL_MAX_MS = 60_000;

export const UNPAID_BANNER_HEIGHT_VAR = "--unpaid-banner-height";

export const SUPPORT_TICKET_SUBJECT = "Question sur un règlement en attente";

export const LOADING_LABEL = "Chargement de votre espace";

// Test mode is excluded so a developer's .env.local never leaks into the suites;
// the DEV flag lets the bundler drop the override from production builds.
export const DEV_MOCK_VALUE: string | undefined =
  import.meta.env.DEV && import.meta.env.MODE !== "test" ? import.meta.env.VITE_MOCK_UNPAID_INVOICES : undefined;

/** Said when Yeati asks for a new RIB and mandate, as when the debited account was closed. */
export const NEW_PAYMENT_METHOD_NOTICE = "Un nouveau moyen de paiement est nécessaire : renseignez un nouveau RIB pour le prélèvement.";
